export const HOVER_SUBMENU_OVERLAP_PX = 4
export const HOVER_SUBMENU_VIEWPORT_PADDING_PX = 8

export type HoverSubmenuRect = {
  top: number
  left: number
  right: number
  bottom: number
  width: number
  height: number
}

export type HoverSubmenuSize = {
  width: number
  height: number
}

export type HoverSubmenuViewport = {
  width: number
  height: number
}

export type HoverSubmenuPositionOptions = {
  overlap?: number
  padding?: number
  offsetY?: number
}

export const shouldOpenHoverSubmenuRight = (
  submenuWidth: number,
  spaceRight: number,
  spaceLeft: number,
) => {
  if (submenuWidth <= 0) {
    return spaceRight >= spaceLeft
  }

  const fitsRight = spaceRight >= submenuWidth
  const fitsLeft = spaceLeft >= submenuWidth

  if (fitsRight && !fitsLeft) {
    return true
  }
  if (fitsLeft && !fitsRight) {
    return false
  }
  if (fitsRight && fitsLeft) {
    return true
  }

  return spaceRight >= spaceLeft
}

export const getHoverSubmenuPosition = (
  trigger: HoverSubmenuRect,
  submenu: HoverSubmenuSize,
  viewport: HoverSubmenuViewport,
  options: HoverSubmenuPositionOptions = {},
) => {
  const overlap = options.overlap ?? HOVER_SUBMENU_OVERLAP_PX
  const padding = options.padding ?? HOVER_SUBMENU_VIEWPORT_PADDING_PX
  const offsetY = options.offsetY ?? 0

  const leftWhenRight = trigger.right - overlap
  const leftWhenLeft = trigger.left - submenu.width + overlap
  const spaceRight = viewport.width - padding - leftWhenRight
  const spaceLeft = trigger.left + overlap - padding
  const openRight = shouldOpenHoverSubmenuRight(submenu.width, spaceRight, spaceLeft)

  let left = openRight ? leftWhenRight : leftWhenLeft
  let top = trigger.top - offsetY

  if (submenu.height > 0 && top + submenu.height > viewport.height - padding) {
    top = viewport.height - padding - submenu.height
  }

  const maxLeft = Math.max(padding, viewport.width - padding - submenu.width)
  left = Math.min(Math.max(padding, left), maxLeft)
  top = Math.min(Math.max(padding, top), Math.max(padding, viewport.height - padding - submenu.height))

  return {
    top,
    left,
  }
}
